import Link from "next/link";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Rating from "@mui/material/Rating";
import styled from "@mui/material/styles/styled"; // GLOBAL CUSTOM COMPONENTS

import Image from "../../Image";
import { H5 } from "../../Typography";
import { FlexBox } from "../../flex-box"; // LOCAL CUSTOM HOOK

import useProduct from "../use-product"; // LOCAL CUSTOM COMPONENTS

import DiscountChip from "../discount-chip";
import ProductPrice from "../product-price";
import AddToCartButton from "./add-to-cart";
import FavoriteButton from "./favorite-button"; // STYLED COMPONENT
import { toAssetImages } from "src/lib/utils";
import { keyframes } from "@mui/material/styles";

const Wrapper = styled(Card)({
  width: "100%",
  overflow: "hidden",
  position: "relative",
  marginBottom: "1.25rem",
});

const FeatureImgBox = styled("div", { shouldForwardProp: (props) => props !== "bgImg" })(
  ({ theme, bgImg }) => ({
    margin: "auto",
    overflow: "hidden",
    position: "relative",
    backgroundImage: bgImg ? `url('${toAssetImages(bgImg)}')` : theme.palette.warning[50],
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  }),
);

// ===========================================================
const ProductCard9 = ({ product }) => {
  const {
    slugName,
    imageUrl,
    name: title,
    salePrice: price,
    off = 0,
    finalRating,
    isFeature,
    bgImg,
  } = product || {};
  const { cartItem, handleCartAmountChange, isFavorite, toggleFavorite } = useProduct(slugName);

  const handleIncrementQuantity = () => {
    handleCartAmountChange({ product, quantity: (cartItem?.quantity ?? 0) + 1 });
  };

  const handleDecrementQuantity = () => {
    handleCartAmountChange({ product, quantity: (cartItem?.quantity ?? 0) - 1 });
  };

  return (
    <Wrapper>
      {/* PRODUCT FAVORITE BUTTON */}
      <FavoriteButton isFavorite={isFavorite} toggleFavorite={toggleFavorite} />

      <Grid container spacing={1}>
        <Grid item sm={3} xs={12}>
          <Box position="relative">
            {/* DISCOUNT PERCENT CHIP IF AVAILABLE */}
            <DiscountChip discount={off} />

            {/* PRODUCT IMAGE / THUMBNAIL */}
            {isFeature ? (
              <FeatureImgBox bgImg={bgImg}>
                <Image src={toAssetImages(imageUrl)} alt={title} width="100%" />
              </FeatureImgBox>
            ) : (
              <Image src={toAssetImages(imageUrl)} alt={title} width="100%" />
            )}
          </Box>
        </Grid>

        <Grid item sm={9} xs={12}>
          <FlexBox flexDirection="column" justifyContent="center" height="100%" p={2}>
            {/* PRODUCT TITLE / NAME */}
            <Link href={`/product/${slugName}`}>
              <H5 fontWeight="600" my="0.5rem">
                {title}
              </H5>
            </Link>

            {/* PRODUCT RATING / REVIEW  */}
            <Rating size="small" value={finalRating ?? 5} color="warn" readOnly />

            {/* PRODUCT PRICE */}
            <ProductPrice price={price} discount={off} />

            {/* PRODUCT ADD TO CART BUTTON */}
            <AddToCartButton
              quantity={cartItem?.quantity}
              handleDecrement={handleDecrementQuantity}
              handleIncrement={handleIncrementQuantity}
            />
          </FlexBox>
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default ProductCard9;
